import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { responsive } from '@hivebrite/design-system/Theme';

const PublicationCoverPicture = ({
  coverPicture,
  defaultCoverPicture,
  dataTestId,
  ...props
}) => (
  <WrapperStyled data-testid={dataTestId}>
    <ImageStyled
      as="img"
      src={coverPicture}
      onError={(e) => (e.target.src = defaultCoverPicture)}
      alt=""
      {...props}
    />
  </WrapperStyled>
);

export default PublicationCoverPicture;

const WrapperStyled = styled(Box)`
  background: linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.6));
  ${responsive('m')`
    border-top-left-radius: ${({ theme }) =>
      `${theme.themeVariables.globalBorderRadius}px`};
    border-top-right-radius: ${({ theme }) =>
      `${theme.themeVariables.globalBorderRadius}px`};
  `}
`;

const ImageStyled = styled(Box)`
  background-color: white;
  object-fit: cover;
  aspect-ratio: 1600 / 600;
  width: ${(props) => props.width || '100%'};
  height: 100%;
  ${responsive('m')`
    border-top-left-radius: ${({ theme }) =>
      `${theme.themeVariables.globalBorderRadius}px`};
    border-top-right-radius: ${({ theme }) =>
      `${theme.themeVariables.globalBorderRadius}px`};
  `}
`;
